import { Component, inject } from '@angular/core';
import { InternalOrderTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InternalOrderTypeCreateDto,
  InternalOrderTypeDto,
  InternalOrderTypeExcelDownloadDto,
  InternalOrderTypeUpdateDto,
} from '../proxy/controlling/dtos/internal-order-type';
import { INTERNALORDERTYPE_CONFIG, INTERNALORDERTYPE_FIELDS } from './internal-order-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-internal-order-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InternalOrderTypeService, ConfirmationService],
  templateUrl: './internal-order-type.html',
  styleUrl: './internal-order-type.scss',
})
export class InternalOrderType extends BaseCrudComponent<
  InternalOrderTypeDto,
  InternalOrderTypeCreateDto,
  InternalOrderTypeUpdateDto,
  InternalOrderTypeExcelDownloadDto
> {
  service = inject(InternalOrderTypeService);
  config = INTERNALORDERTYPE_CONFIG;
  fields = INTERNALORDERTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: InternalOrderTypeDto): InternalOrderTypeUpdateDto {
    return {
      name: data.name,
      isProjectTypeMandatory: data.isProjectTypeMandatory,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InternalOrderType';
  }
}
